import React from 'react';
import { List, notification, Button, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import { Link } from 'react-router-dom';
import Loading from '../../../common/Loading';

import getTipoCertificaciones from '../../../../graphql/querys/otros/getTipoCertificaciones.graphql';
import deleteTipoCertificacion from '../../../../graphql/mutations/otros/deleteTipoCertificacion.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getTipoCertificaciones, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteTipoCertificacion, {
    name: 'deleteTipoCertificacion',
    options: {
      refetchQueries: [{ query: getTipoCertificaciones }],
    },
  })
)
class VerTipoCertificaciones extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este tipo de certificacion?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteTipoCertificacion({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Tipo de certificacion eliminada',
              description:
                'Se ha eliminado correctamente el tipo de certificacion',
            });
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el tipo de certificacion'
            );
            console.log(err);
            errorService(err, {
              _id: id,
            });
            Modal.error({
              title: 'Error en la eliminacion del tipo de certificacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { loading } = this.state;

    let listaTipoCertificaciones = this.props.data.getTipoCertificaciones;

    if (!listaTipoCertificaciones) {
      listaTipoCertificaciones = [];
    }

    return (
      <div>
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          dataSource={listaTipoCertificaciones}
          renderItem={item => (
            <List.Item
              style={{ margin: 15 }}
              actions={[
                // eslint-disable-next-line react/jsx-key
                <Button
                  onClick={() =>
                    this.props.history.push(
                      `/admin/otros/tipo_certificacion/${item._id}`
                    )
                  }
                >
                  Editar
                </Button>,
                // eslint-disable-next-line react/jsx-key
                <Button type="danger" onClick={() => this.onDelete(item._id)}>
                  Eliminar
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  <Link to={`/admin/otros/tipo_certificacion/${item._id}`}>
                    <h2>Categoria con titulo de: {item.nombre}</h2>
                  </Link>
                }
                // description={<h3>{item.descripcion} </h3>}
              />
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default withApollo(VerTipoCertificaciones);
